/* FizzyIQ — Science sticky-stacking cards (scs-). Reveals each card's visual
   (collage tiles / focus chart) the first time it scrolls into view. */
(function () {
  'use strict';

  function initSection(root) {
    if (!root || root.dataset.scsInit === '1') return;
    root.dataset.scsInit = '1';

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-scs-card]'));
    if (!cards.length) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

    function reveal(card) {
      card.classList.add('in-view');
      if (reduce && reduce.matches) return;
      /* Start the SMIL pen 0.3s in, alongside the stroke draw. */
      Array.prototype.forEach.call(card.querySelectorAll('animateMotion'), function (m) {
        try { m.beginElementAt(0.3); } catch (e) { /* SMIL unavailable; the pen stays hidden */ }
      });
    }

    /* Anchor arrivals (/pages/the-science#how-it-works) land mid-page without
       a scroll, where IO delivery is least reliable — reveal everything at
       once rather than risk a blank section next to the sticky header. */
    if (!('IntersectionObserver' in window) || window.location.hash) {
      cards.forEach(reveal);
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { reveal(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.25, rootMargin: '0px 0px -10% 0px' });

    cards.forEach(function (c) { io.observe(c); });

    /* Fallback: reveal anything still hidden after a moment (covers contexts
       where the observer never delivers — e.g. very tall sticky decks). */
    window.setTimeout(function () {
      cards.forEach(function (c) {
        var r = c.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) reveal(c);
      });
    }, 1200);
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('.scs'), initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target || !e.target.querySelector) return;
    var root = e.target.querySelector('.scs');
    if (root) initSection(root);
  });
})();
